<template>
  <div>
    <v-card class="ma-4 mt-2">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
          :allowGrouping="false"
          :allowFilterPanel="false"
          :title="title"
        >
          <template slot="columnTemplates" slot-scope="row">
            <div v-if="row.data.field == 'State'">
              <span>{{ getState(row.data.item) }}</span>
            </div>
          </template>

          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  v-if="row.data.item.State != 2"
                  @click.prevent="start(row.data.item)"
                >
                  <v-icon color="green">mdi-play</v-icon>
                </a>
              </template>
              <span>{{ $t("Start") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  v-if="row.data.item.State == 2"
                  @click.prevent="finish(row.data.item)"
                >
                  <v-icon color="accent">mdi-stop</v-icon>
                </a>
              </template>
              <span>{{ $t("Finish") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  v-if="row.data.item.State != 2"
                  @click.prevent="editItem(row.data.item)"
                  class="pl-2 pr-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }" v-if="row.data.item.State == 2">
                <a
                  v-on="on"
                  @click.prevent="viewItem(row.data.item)"
                  class="pl-2 pr-2"
                >
                  <v-icon color="primary">mdi-information</v-icon>
                </a>
              </template>
              <span>{{ $t("Information") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  v-if="row.data.item.State != 2"
                  @click.prevent="deleteItem(row.data.item)"
                  class="pl-2 pr-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <DelegationModal :ref="modalKey" @on-item-saved="onItemSaved" />
  </div>
</template>

<script>
import DelegationService from '@/services/DelegationService';
import DelegationModal from '@/components/administration/delegation/DelegationModal.vue';
import DelegationState from '@/ecm/variables/DelegationState';
import Utils from '@/ecm/common/Utils';

export default {
    components: {
        DelegationModal,
    },
    data() {
        return {
            title: this.$t('Delegations'),
            grid: {
                key: 'delegationGrid',
                dataSource: DelegationService.getGrid(),
                columns: [
                    {
                        field: 'Description',
                        caption: this.$t('Description'),
                        type: 'string',
                    },
                    {
                        field: 'StartDate',
                        caption: this.$t('StartDate'),
                        type: 'date',
                        format: this.$store.getters['account/user'].MetricDateFormat
                    },
                    {
                        field: 'EndDate',
                        caption: this.$t('EndDate'),
                        type: 'date',
                        format: this.$store.getters['account/user'].MetricDateFormat
                    },
                    {
                        field: 'State',
                        caption: this.$t('State'),
                        type: 'string',
                        hasTemplate: true,
                    },
                    {
                        field: 'DelegatorUserName',
                        caption: this.$t('DelegatedBy'),
                        type: 'string',
                    },
                    {
                        field: 'DelegatedUserNames',
                        caption: this.$t('Users'),
                        type: 'string',
                    },
                ],
            },
            modalKey: 'modalDelegation',
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        },
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        start(delegation) {
            this.$confirm(this.$t('DelegationStartConfirm'), {
                title: this.$t('Start'),
                icon: 'mdi-start',
                color: 'green',
                buttonTrueText: this.$t('Start'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    DelegationService.start(delegation.Id).then((result) => {
                        if (result) {
                            this.gridInstance.refresh();
                            Utils.toast.success(
                                `${this.$t('Delegation')} ${this.$t('StartedManually')}`
                            );
                        }
                    });
                }
            });
        },
        finish(delegation) {
            this.$confirm(this.$t('DelegationFinishConfirm'), {
                title: this.$t('Finish'),
                icon: 'mdi-stop',
                color: 'red',
                buttonTrueText: this.$t('Finish'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    DelegationService.finish(delegation.Id).then((result) => {
                        if (result) {
                            this.gridInstance.refresh();
                            Utils.toast.success(
                                `${this.$t('Delegation')} ${this.$t('EndedManually')}`
                            );
                        }
                    });
                }
            });
        },
        deleteItem(delegation) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    DelegationService.delete(delegation.Id).then((result) => {
                        if (result) {
                            this.gridInstance.refresh();
                            Utils.toast.success(this.$t('Delegation') + ' ' + this.$t('DeletedSuccessfullyFem'));
                        }
                    });
                }
            });
        },
        editItem(dto) {
            this.modalInstance.edit(dto.Id);
        },
        viewItem(dto) {
            this.modalInstance.view(dto.Id);
        },
        add() {
            this.modalInstance.new();
        },
        onItemSaved() {
            this.gridInstance.refresh();
        },
        getState(data) {
            switch (data.State) {
            case DelegationState.Pending:
                return this.$t('Pending');
            case DelegationState.Started:
                return this.$t('Started');
            case DelegationState.Ended:
                return this.$t('Ended');
            case DelegationState.Failed:
                return this.$t('Failed');
            default:
                return '';
            }
        },
    },
};
</script>
